<script lang="ts">
  import LotteryStatsCard from "./LotteryStatsCard.svelte";
  import TaskSection from "./TaskSection.svelte";
  import type { ActivityDetail } from "../lib/restful";

  let {
    activityData = null,
    openAccountDisabled = false,
    depositDisabled = false,
    tradeDisabled = false,
    ipoDisabled = false,
    onOpenAccount = undefined,
    onDeposit = undefined,
    onTrade = undefined,
    onIpo = undefined,
    onMoreRewards = undefined,
  }: {
    activityData: ActivityDetail | null;
    /** 去开户按钮是否禁用 */
    openAccountDisabled?: boolean;
    /** 去入金按钮是否禁用 */
    depositDisabled?: boolean;
    /** 去交易按钮是否禁用 */
    tradeDisabled?: boolean;
    /** 去认购按钮是否禁用 */
    ipoDisabled?: boolean;
    onOpenAccount?: () => void;
    onDeposit?: () => void;
    onTrade?: () => void;
    onIpo?: () => void;
    onMoreRewards?: () => void;
  } = $props();
</script>

<div class="flex w-full flex-col items-center">
  <LotteryStatsCard {activityData} />
</div>

<TaskSection
  {openAccountDisabled}
  {depositDisabled}
  {tradeDisabled}
  {ipoDisabled}
  {onOpenAccount}
  {onDeposit}
  {onTrade}
  {onIpo}
  {onMoreRewards}
/>
